import { render, staticRenderFns } from "./dialogNewDebtBase.vue?vue&type=template&id=53feaece"
import script from "./dialogNewDebtBase.vue?vue&type=script&lang=js"
export * from "./dialogNewDebtBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports